import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 10H22V12H21V20H22V22H16V15H8V22H2V20H3V12H2V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 22V17H14V22H10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 2H5V4H6V8H18V4H19V2ZM13.002 3.99805V6.00195H10.998V3.99805H13.002Z"}}]};

const DoubleStoreyFilled = Vue.extend<IconProps>({
  name: 'DoubleStoreyFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'double-storey-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DoubleStoreyFilled;
